module.exports = __webpack_public_path__ + "static/img/exploit6.eacf7e99.png";